import { lazy } from "react";

export const ProjectTeamView = lazy(() => import("./ProjectTeamView"));
export const ProjectMembersView = lazy(() => import("./ProjectMembersView"));
export const ProjectGroupsView = lazy(() => import("./ProjectGroupsView"));
